<template>
  <app-layout>
    <div class="page-home">
      <app-home-cover></app-home-cover>
      <div class="container-1240">
        <div class="home-verticals-container mt-lg-12 mt-8 flex flex-col justify-center items-center">
          <div v-for="(banner, index) in active_banners" :key="banner.id" class="px-md-3">
            <img :src="banner.image" :alt="banner.alt" class="hidden lg:block">
            <img :src="banner.image_mobile" :alt="banner.alt" class="lg:hidden">
            <div v-if="active_banners.length > 1 && index < active_banners.length" class="my-8"></div>
          </div>
        </div>
        <app-home-verticals></app-home-verticals>
      </div>
      <app-reviews-module></app-reviews-module>
      <app-banner-newsletter background="/img/background-image-newsletter.jpg"></app-banner-newsletter>
    </div>
  </app-layout>
</template>


<script lang="ts">
import router from "../router";
import { SET_SEARCH_DATE, SET_SEARCH_DESTINY } from '../store/search/mutation-types';
import handleAppBarItems from "../utils/handleAppBarItems";

export default {
  data() {
    return {
      active_banners: []
    }
  },
  created() {
    this.$store.commit(SET_SEARCH_DESTINY, null);
    this.$store.commit(SET_SEARCH_DATE, null);
    this.$eventHub.$emit(
      "update-header",
      handleAppBarItems.call(this, router.currentRoute)
    );
    this.fetchBanners();
  },
  methods: {
    async fetchBanners() {
      try {
        const response = await fetch('/api/banners');
        this.active_banners = await response.json();
      } catch (error) {
        console.error('Error fetching banners:', error);
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../sass/variables";

.page-home {

  .page-section {
    padding: 6.25rem 0;


    &[data-section-name="blog"] {
      .horizontal-carousel {
        margin: 1.5rem 0 2rem;
      }
    }

    @media screen and (max-width: $breakpoint-landing-phone) {
      padding: 2.25rem 0;
    }

    .grid-cards {
      margin: 2.5rem 0 3rem;
    }
  }
}
</style>
